import { render, staticRenderFns } from "./TableFooterResults.vue?vue&type=template&id=4db6b525&"
import script from "./TableFooterResults.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableFooterResults.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db6b525')) {
      api.createRecord('4db6b525', component.options)
    } else {
      api.reload('4db6b525', component.options)
    }
    module.hot.accept("./TableFooterResults.vue?vue&type=template&id=4db6b525&", function () {
      api.rerender('4db6b525', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/TableFooterResults.vue"
export default component.exports